<div
  #alertWarningBanner
  [attr.role]="role"
  [attr.tabindex]="tabIndex"
  [ngClass]="setClassNames()"
  data-test-alert-warning-banner="true"
>
  <p *ngIf="cntError" class="idp-alert-warning-message-text">
    <i aria-hidden="true" class="idp-icon-alert"></i>
    <span [innerHTML]="errorMessage"></span>
    <a
      *ngIf="!isWarning"
      (click)="focusFirstInvalidField()"
      class="idp-alert-link"
      href="javascript:void(0)"
    >
      {{ cntError }}
      <span *ngIf="cntError > 1; else itemShow">items</span>
      indicated.
    </a>
  </p>
  <ng-template #itemShow>
    <span>item</span>
  </ng-template>
</div>
